<template>
  <div class="blog-main-content">
    <BlogList class="right"/>
    <h1>Travincal (Terror Zone) Farming Guide</h1>
    <p>When Travincal becomes a Terror Zone, it offers an excellent location for farming high runes. Since the monster density is relatively low, solo farming is recommended over group play to maximize efficiency.</p>

    <h2>Farming Route Planning</h2>
    <ol>
        <li>Use the <strong>Travincal waypoint (Act 3)</strong> to enter directly.</li>
        <li>Clear outer mobs first to avoid interference during the main fight.</li>
        <li>Focus on the <strong>High Council</strong>, who are usually gathered around the temple area.</li>
        <li>After clearing, reset the game and repeat the process.</li>
    </ol>
    <p>⏳ <strong>Each run should take around 1-2 minutes</strong> for optimal efficiency.</p>

    <div id="slot-content_mpu" class="content-ad-mpu"/>

    <h2>Recommended Builds</h2>
    <p>Since Travincal’s High Council members are often immune to fire and lightning, while dealing strong fire, cold, and physical damage, the following builds are highly effective:</p>
    <ul>
        <li><strong>Fist of the Heavens Paladin (FoH Paladin)</strong>
            <ul>
                <li><strong>Skills:</strong> Fist of the Heavens</li>
                <li><strong>Advantages:</strong> Fist of the Heavens ignores obstacles and deals high AoE lightning damage, making it one of the best choices for clearing Travincal.</li>
            </ul>
        </li>
        <li><strong>Whirlwind Barbarian (WW Barb)</strong>
            <ul>
                <li><strong>Skills:</strong> Whirlwind + Find Item</li>
                <li><strong>Advantages:</strong> Physical damage is not affected by enemy immunities, and Find Item allows an additional loot roll on High Council corpses.</li>
            </ul>
        </li>
        <li><strong>Poison Necromancer (Poison Nova Necro)</strong>
            <ul>
                <li><strong>Skills:</strong> Poison Nova + Lower Resist</li>
                <li><strong>Advantages:</strong> Poison damage bypasses most elemental immunities, and Lower Resist helps further weaken enemies.</li>
            </ul>
        </li>
        <li><strong>Hammerdin (Blessed Hammer Paladin)</strong>
            <ul>
                <li><strong>Skills:</strong> Blessed Hammer + Concentration</li>
                <li><strong>Advantages:</strong> Magic damage ignores almost all resistances, making this build highly efficient for Travincal farming.</li>
            </ul>
        </li>
        <li><strong>Blizzard Sorceress (Cold Sorc)</strong>
            <ul>
                <li><strong>Skills:</strong> Blizzard + Cold Mastery</li>
                <li><strong>Advantages:</strong> Some High Council members are not cold-immune, and Cold Mastery greatly reduces their resistance. However, some may be immune, so this build is slightly less efficient.</li>
            </ul>
        </li>
    </ul>

    <div>
      <img class="m-1 w-100" alt="Travincal run" src="@/assets/runs/travincal-run.png">
    </div>

    <h2>Farming Rewards</h2>
    <ul>
        <li><span class="highlight">High Rune Farming</span> – Travincal has a relatively high drop rate for runes such as <strong>Cham, Jah, Ber, Sur, Lo, and Ohm</strong>.</li>
        <li><span class="highlight">Elite Gear & Gold</span> – The High Council drops unique, set items, jewelry, and large amounts of gold, making it ideal for gambling.</li>
    </ul>

    <h2>Key Farming Tips</h2>
    <ul>
        <li>✔ <span class="highlight">Avoid prolonged fights</span> – The High Council’s fire and lightning attacks are deadly, so use hit-and-run tactics or burst damage to clear them quickly.</li>
        <li>✔ <span class="highlight">Watch out for Mana Burn</span> – Some elite High Council members may have Mana Burn, which can be dangerous for mana-dependent classes.</li>
        <li>✔ <span class="highlight">Optimize farming time</span> – Aim for <strong>1-2 minutes per run</strong>, resetting the game afterward to maximize efficiency.</li>
    </ul>
  </div>
</template>

<script>
import BlogList from '../BlogList.vue'

export default {
  name: 'Travincal',

  components: {
    BlogList,
  },
}
</script>